import React, {useState, useEffect, useContext} from 'react'
import Layout from "components/sales/layout/layout";
import DivLayout from 'components/sales/divLayout/divLayout';
import localization from "assets/localization/localization";
import PanelCardWithHeading from 'components/tickets/panelCardWithHeading';
import DocumentView from 'components/sales/downloadDocView/documentView';
import Images from 'assets/images/imageData';

const ToolkitInspectionView = ({
    match,
    fetchMaterialInspection,
    fetchMaterialInspetionList
}) => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(()=> {
        (async()=> {
            setIsLoading(true)
            await fetchMaterialInspection(match.params.id)
            setIsLoading(false)
        })();
    }, [])

    return(
        <Layout
            title="Inspection Reports"
            isGoback
            isLoading={isLoading}
        >

            {fetchMaterialInspetionList.length>0 && fetchMaterialInspetionList.map(element => {
                return (
                <PanelCardWithHeading title={element?.material_name}>
                <div className="details-listing" style={{"marginBottom":"40px"}}>
                  <DivLayout
                    heading="Status"
                    data={element?.status}
                    status={true}
                  />
                  <DivLayout
                    heading="Remarks"
                    data={element?.remarks}
                  />
                   <DivLayout
                    heading="Created At"
                    data={new Date(element?.created_at).toLocaleDateString()}
                  />
                  { element?.image?.length>0 && element?.image.map((image,index)=>{
                      return <DocumentView key={index + 1}
                      title={`${localization.attachment} ${
                        index + 1
                      }`} attachment={image} />
                  })
                    
                  }
                </div>
                
                </PanelCardWithHeading>)
            })}

        </Layout>
    )

}

export default ToolkitInspectionView